const partners = [
  {
    path: '/partners',
    name: 'Partners',
    component: () => import('@/views/partners'),
    children: [],
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/partners/:partnerId',
    name: 'PartnersDetails',
    component: () => import('@/views/partners/Details'),
    children: [],
    meta: {
      requiresAuth: false
    },
    props: (route) => ({ partnerId: route.params.partnerId })
  },
]

export default partners
